/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CollectionsModule
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { AlertSyslogConfigItem } from 'items/alert-syslog-config.item.factory';

/**
 * @description AlertSyslogConfig collection
 * @author Guru Prasad H K, alextsg
 */
export class AlertSyslogConfigCollection extends Collection {
    public static ngDependencies = [AlertSyslogConfigItem];

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'alertsyslogconfig',
            permissionName: AviPermissionResource.PERMISSION_ALERTSYSLOGCONFIG,
            windowElement: 'lazy-load',
            ...args,
        };

        super(extendedArgs);

        this.itemClass_ = this.getNgDependency(AlertSyslogConfigItem);
    }
}
